<template>
  <div>
    <div class="pt-3">
      <div class="rounded-full bg-smoke-100 flex items-center py-2 border border-dark-b px-3">
        <input
          class="app-input bg-smoke-100 flex-grow text-center"
          placeholder="More Categories"
          v-model="keyword"
        >
        <i class="icon-search opacity-50"></i>
      </div>
    <div v-if="!categoryExist" class="pt-3 text-red-700 text-center text-sm">No Results Found</div>
    </div>
    <div class="pt-5">
      <div :class="{'max-h-44 overflow-auto': !showAll}">
        <div v-for="cat in categories" :key="`cat-${cat.name}`">
          <div
            class="flex items-center py-1 cursor-pointer"
            v-if="keywordExist(cat) && categorySelected"
            :class="{'text-green cursor-text': categorySelected.toLowerCase() === cat.name.toLowerCase()}"
            @click="selectCategory(cat)"
          >
            <span class="pl-4 font-medium" :class="{'font-semibold': subCategoriesExist }">{{ cat.name }}</span>
          </div>
          <div class="pl-3">
            <span v-for="sub in cat.subCategories" :key="`sub-${sub.name}`">
              <div
                v-if="keywordExist(sub) && categorySelected"
                class="flex items-center py-1 cursor-pointer"
                :class="{'text-green cursor-text': categorySelected.toLowerCase() === sub.name.toLowerCase()}"
                @click="selectCategory(sub)"
              >
                <span class="pl-4">{{ sub.name }}</span>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-3" v-if="categoryExist > 6">
      <p
        v-if="showAll"
        class="text-green underline cursor-pointer"
        @click="showAll = false"
      >
        Show Less
      </p>
      <p
        v-else
        class="text-green underline cursor-pointer"
        @click="showAll = true"
      >
        Show All
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: '',
      showAll: false
    }
  },
  props: {
    categories: { type: Array },
    categorySelected: {type: String}
  },
  computed: {
    categoryExist() {
      let count = 0
      if (!this.keyword) return this.categories.length
      for(let cat of this.categories) {
        let count2 = cat.name.toLowerCase().includes(this.keyword.toLowerCase()) 
        if (count2) count++
        else if (cat.subCategories) {
          for(let subCat of cat.subCategories) {
            let count3 = subCat.name.toLowerCase().includes(this.keyword.toLowerCase())
            if (count3) count++ 
          }
        }
      }
      return count
    },
    subCategoriesExist () {
      let res = false
      for(let cat of this.categories){
        if (cat.subCategories.length > 0) { return true }
      }
      return res
    }
  },
  methods: {
    selectCategory(val) {
      this.$router.push(`/${val.slug}`)
    },
    keywordExist(category) {
      let exist = false
      exist = category.name.toLowerCase().includes(this.keyword.toLowerCase())
      if (exist) return exist
      else if (category.subCategories) {
        exist = category.subCategories.some(sub => sub.name.toLowerCase().includes(this.keyword.toLowerCase()))
      }
      return exist
    }
  }
}
</script>

